import React, { Component } from "react";
import { connect } from "react-redux";
import selectn from "selectn";
import debounce from "lodash/debounce";
import { Helmet } from "react-helmet";

import AuthorSubscribe from "../AuthorSubscribe";
import UserHeader from "../../../components/Library/UserHeader";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import StoriesStream from "../../../components/Library/StoriesStream";

import { getAuthor, getAuthorStories } from "../../actions/author";
import analytics from "../../../utils/analytics";

import styles from "./Author.css";
import { FRONTEND_ROOT } from "../../../config/constants";

class Author extends Component {
  constructor(props) {
    super(props);
    this.loadNextStories = this.loadNextStories.bind(this);
    this.state = {
      username: null,
    };
  }

  componentDidMount() {
    this.scrollListener = debounce(this.handleScroll, 50);
    window.addEventListener("scroll", this.scrollListener);

    this.setState({ username: selectn("match.params.username", this.props) });
  }

  componentWillReceiveProps(nextProps) {
    const username = selectn("match.params.username", this.props);
    const nextUsername = selectn("match.params.username", nextProps);
    if (username !== nextUsername) {
      this.setState({ username: nextUsername });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.username !== nextState.username) {
      this.props.getAuthor(nextState.username);
      this.props.getAuthorStories(nextState.username);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener);
  }

  handleScroll = () => {
    const cards = document.getElementsByClassName("story-card");
    if (cards) {
      for(let i=0; i < cards.length; i++) {
        let card = cards[i];

        if (analytics.isStoryInView(card) && this.state.inViewId !== card.id) {
          this.setState({ inViewId: card.id });
          setTimeout(() => {
            if (analytics.isStoryInView(card)) {
              const stories = this.props.storiesStream.results.filter((story) => story.id === card.id);
              if (stories && stories.length) {
                const stream = this.props.author.display_name;
                analytics.userScrollsStoryIntoView({ story: stories[0], stream });
              }
            }
          }, 3000);
          break;
        }
      }
    }
  };

  loadNextStories(page) {
    return this.props.getAuthorStories(this.state.username, { page }, true);
  }

  renderMeta() {
    if (!this.props.author || !this.props.author.display_name) return null;
    const ogUrl = `${FRONTEND_ROOT}/authors/${this.props.match.params.username}/`;
    return (
      <Helmet>
        <title>{this.props.author.display_name} - Axios</title>
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={`${this.props.author.display_name} on Axios`} />
      </Helmet>
    );
  }

  render() {
    const { author } = this.props;
    if (!author) return null;

    return (
      <Layout className={styles.root} includeHeader={true} headerComponent={<UserHeader person={author}/>}>
        {this.renderMeta()}
        <Sidebar className={styles.sidebar}>
          <AuthorSubscribe author={author}/>
        </Sidebar>
        <Content ariaLabel="Stories">
          <StoriesStream stories={this.props.storiesStream} next={this.loadNextStories} showUnread={false}/>
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    author: state.authors.data,
    storiesStream: state.storiesStream,
  };
};

export default connect(mapStateToProps, { getAuthor, getAuthorStories })(Author);



// WEBPACK FOOTER //
// ./src/author/components/Author/Author.js